export default __webpack_public_path__ + "static/media/LoginBackground_1920x1080.21ee2426.jpg";